import {DropzoneArea} from "material-ui-dropzone";
import React, {useEffect, useState} from "react";
import {fileUploadToAzureStorage, findBoardFiles} from "../../lib/api/file";
import {useRecoilValue} from "recoil";
import {userState} from "../../state/globalState";
import QuestionDropzoneFileItem from "./QuestionDropzoneFileItem";

function QuestionDropzone({ brdNo }) {
    const userInfo = useRecoilValue(userState);
    const [questionFiles, setQuestionFiles] = useState([]);

    useEffect(() => {
        getFiles(brdNo, userInfo.stdYear);
    }, []);

    const getFiles = async (admnNo, stdYear) => {
        const { data } = await findBoardFiles(admnNo, stdYear);
        if (data.success) {
            const files = data.payload;
            setQuestionFiles(files);
        }
    }
    const handleChange = async (files) => {
        const fileObj = files[files.length - 1];

        if (fileObj !== undefined) {
            // 실시간 파일 업로드
            const opts = {
                stdYear: userInfo.stdYear,
                admnNo: brdNo,
                attcFileBizGcd: "hc056003",
            }

            const { data } = await fileUploadToAzureStorage(fileObj, opts);
            if (data.success) {
                const { resultCode, resultMsg } = data.payload;
                if (resultCode === "0000") {
                    await getFiles(brdNo, userInfo.stdYear);
                }
            }
        }
    };

    return (
        <div>
            <br/>
            <div>
                <DropzoneArea
                    acceptedFiles={[
                        'application/pdf',
                        'image/jpeg',
                        'image/png',
                        'application/vnd.ms-excel',
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        'application/msword',
                        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        'application/zip',
                        '.hwp'
                    ]}
                    filesLimit={20}
                    dropzoneText={'파일을 선택하거나 또는 여기로 끌어 주세요.'}
                    maxFileSize={30000000}
                    // showFileNames={true}
                    showPreviewsInDropzone={false}
                    showAlerts={false}
                    onChange={handleChange}
                    // onDelete={handleDelete}
                    // initialFiles={etcFile && etcFile.map((file) => file.name)}
                />
                {questionFiles && questionFiles.map((file) => <QuestionDropzoneFileItem
                    key={file.fileUuid}
                    brdNo={brdNo}
                    setQuestionFiles={setQuestionFiles}
                    {...file}
                />)}
            </div>
        </div>
    )
}

export default QuestionDropzone;
